// Central feature flags.
//
// MFA_ENABLED: master switch for the entire two-factor flow. When false:
//   - Root never calls any MFA/AAL endpoint and lets every authenticated
//     user straight into the app (no enrollment, no challenge).
//   - The 2FA card in Settings is hidden.
// This was turned off after persistent client-side auth hangs made the
// TOTP flow unusable for some users. The TOTP factors + recovery codes
// in the database have also been wiped. To re-enable later: flip this to
// true, re-run the MFA migrations if needed, and re-enable TOTP in the
// Supabase dashboard.
export const MFA_ENABLED = false;
